const getTariffList = (state) => {
  return state.main.tariffState.tariffs
}
const getTariffsPaginationOffset = (state) => {
  return state.main.tariffState.tariffsPaginationOffset
}
const getFetchTariffListRequestState = (state) => {
  return state.main.tariffState.fetchTariffListRequestState
}
const getTariffFilter = (state) => {
  return state.main.tariffState.tariffFilter
}
const getCreateTariffRequestState = (state) => {
  return state.main.tariffState.createTariffRequestState
}
const getUpdateTariffRequestState = (state) => {
  return state.main.tariffState.updateTariffRequestState
}
const getDeleteTariffRequestState = (state) => {
  return state.main.tariffState.deleteTariffRequestState
}
const getFetchTariffsCountRequestState = (state) => {
  return state.main.tariffState.fetchTariffsCountRequestState
}
const getCount = (state) => {
  return state.main.tariffState.count
}

const TariffSelectors = {
  getTariffList,
  getTariffsPaginationOffset,
  getFetchTariffListRequestState,
  getTariffFilter,
  getCreateTariffRequestState,
  getUpdateTariffRequestState,
  getDeleteTariffRequestState,
  getFetchTariffsCountRequestState,
  getCount,
}

export default TariffSelectors
